(function () {
  function findVariant(variants, selectedOptions) {
    return variants.find(
      (variant) =>
        variant.options.length === selectedOptions.length &&
        variant.options.every((value, index) => value === selectedOptions[index])
    );
  }

  class MJCProductVariants extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-variant-form]');
      this.variantIdInput = this.querySelector('[data-variant-id]');
      this.price = this.querySelector('[data-variant-price]');
      this.availability = this.querySelector('[data-variant-availability]');
      this.submitButton = this.querySelector('[data-variant-submit]');
      this.submitLabel = this.querySelector('[data-variant-submit-label]');
      this.mainImage = this.querySelector('.mjc-gallery__main-img');
      this.selects = Array.from(this.querySelectorAll('.mjc-product__select'));
      this.thumbnails = Array.from(this.querySelectorAll('.mjc-gallery__thumb'));

      const variantData = this.querySelector('[data-mjc-product-variants]');
      if (!this.form || !this.variantIdInput || !variantData) return;

      try {
        this.variants = JSON.parse(variantData.textContent);
      } catch (error) {
        console.error('Unable to read product variants', error);
        this.disableForm('Unavailable');
        return;
      }

      this.selects.forEach((select) => select.addEventListener('change', () => this.onOptionsChange()));
      this.thumbnails.forEach((thumbnail) =>
        thumbnail.addEventListener('click', () => this.showThumbnail(thumbnail))
      );

      const initialVariant = this.variants.find(
        (variant) => String(variant.id) === String(this.dataset.selectedVariantId)
      );
      if (initialVariant) this.selectOptions(initialVariant.options);
      this.applyVariant(initialVariant || findVariant(this.variants, this.selectedOptions()), false);
    }

    selectedOptions() {
      return this.selects.map((select) => select.value);
    }

    selectOptions(options) {
      this.selects.forEach((select, index) => {
        if (options[index] !== undefined) select.value = options[index];
      });
    }

    onOptionsChange() {
      this.applyVariant(findVariant(this.variants, this.selectedOptions()), true);
    }

    applyVariant(variant, updateUrl) {
      if (!variant) {
        this.variantIdInput.value = '';
        this.dataset.selectedVariantId = '';
        this.disableForm('Unavailable');
        return;
      }

      this.variantIdInput.value = String(variant.id);
      this.dataset.selectedVariantId = String(variant.id);
      if (this.price) this.price.textContent = variant.price;

      if (variant.available) {
        this.submitButton.disabled = false;
        this.submitButton.removeAttribute('aria-disabled');
        if (this.submitLabel) this.submitLabel.textContent = 'Add to Cart';
        if (this.availability) this.availability.textContent = 'In stock';
      } else {
        this.disableForm('Sold Out');
      }

      if (variant.featuredImage) this.showVariantImage(variant.featuredImage);
      if (updateUrl) this.updateUrl(variant.id);

      this.dispatchEvent(
        new CustomEvent('mjc:variant-change', {
          bubbles: true,
          detail: { variant },
        })
      );
    }

    disableForm(label) {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-disabled', 'true');
      }
      if (this.submitLabel) this.submitLabel.textContent = label;
      if (this.availability) this.availability.textContent = label;
    }

    updateUrl(variantId) {
      if (!window.history || !this.dataset.productUrl) return;
      const url = new URL(this.dataset.productUrl, window.location.origin);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', `${url.pathname}${url.search}`);
    }

    showVariantImage(image) {
      if (!this.mainImage) return;
      this.mainImage.src = image.src;
      this.mainImage.srcset = image.srcset;
      this.mainImage.alt = image.alt || '';
      if (image.width) this.mainImage.width = image.width;
      if (image.height) this.mainImage.height = image.height;
      this.setActiveThumbnail(image.id);
    }

    showThumbnail(thumbnail) {
      if (!this.mainImage) return;
      this.mainImage.src = thumbnail.dataset.imageSrc;
      this.mainImage.srcset = thumbnail.dataset.imageSrcset;
      this.mainImage.alt = thumbnail.dataset.imageAlt || '';
      this.setActiveThumbnail(thumbnail.dataset.imageId);
    }

    setActiveThumbnail(imageId) {
      this.thumbnails.forEach((thumbnail) =>
        thumbnail.classList.toggle('mjc-gallery__thumb--active', String(thumbnail.dataset.imageId) === String(imageId))
      );
    }
  }

  window.MJCProductVariants = { findVariant };
  if (!customElements.get('mjc-product-variants')) {
    customElements.define('mjc-product-variants', MJCProductVariants);
  }
})();
